import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  completeKYCSuccess,
  completeKYCFailure,
} from "../../Action/kyc/completeKYCAction";
import { COMPLETE_KYC } from "../../Action/actionTypes";
import { notifyError } from "../../../Utils/Helper";

function* completeKYCRequest(action) {
  try {
    const { currentPage, rowCount,whitelabelId } = action?.payload?.payload;
    const { data } = yield API.get(`/getkyclist?currentPage=${currentPage}&rowCount=${rowCount}&whitelabelId=${whitelabelId}`);
    if (action?.payload?.callback) {
      yield call(action.payload.callback, data);
    }
    if (data?.meta?.code === 200) {
      yield put(completeKYCSuccess(data?.data));
      if (action?.payload?.callback) {
        yield call(action.payload.callback, data);
      }
    } else {
      yield put(completeKYCFailure());
      notifyError("Invalid Request.");
    }
  } catch (error) {
    yield put(completeKYCFailure());
    notifyError("Invalid Request.");
  }
}

export function* watchCompleteKYCAPI() {
  yield takeEvery(COMPLETE_KYC, completeKYCRequest);
}

export default function* rootSaga() {
  yield all([watchCompleteKYCAPI()]);
}
